var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4017 24.6761L17.9975 17.0007V10H21.107V17.0007L20.7027 24.6761H18.4017ZM19.5833 30.8333C19.0236 30.8333 18.5365 30.6459 18.1219 30.271C17.7073 29.8962 17.5 29.4557 17.5 28.9496C17.5 28.3686 17.6866 27.9094 18.0597 27.572C18.4328 27.2346 18.9407 27.0659 19.5833 27.0659C20.1223 27.0659 20.5991 27.2533 21.0137 27.6282C21.449 28.0031 21.6667 28.4435 21.6667 28.9496C21.6667 29.5119 21.4697 29.9711 21.0759 30.3273C20.682 30.6646 20.1845 30.8333 19.5833 30.8333Z",
    fill: "#8592C7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "#8592C7",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircle);
export default __webpack_public_path__ + "static/media/error-circle.f293bfe6b273370ad75262dfb843323c.svg";
export { ForwardRef as ReactComponent };